import React, { useState } from 'react';

const CollapsiveContent = props => {
  const { title, content } = props;

  const [expandEle, setExpandEle] = useState(false);

  const collapseBtn = e => {
    if (e) e.preventDefault();
    setExpandEle(!expandEle);
  };

  return (
    <div className={`collapsible-wrapper ${expandEle ? '  active' : ''}`}>
      <div className="collapsible" onClick={e => collapseBtn(e)}>
        {title}
      </div>
      <div className="collapsiveContentBody">
        <p
          className="collapsiveTextTp"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      </div>
    </div>
  );
};

export default CollapsiveContent;
